import { FacebookOutlined, GithubOutlined, GoogleOutlined, LinkOutlined, ShareAltOutlined } from "@ant-design/icons";
import { Button, List, notification, Space } from "antd";
import { LinkedAccount } from "services/rest/request";
import { useKeycloak } from "services/keycloak/hook";

import { KeycloakInstance } from "keycloak-js";
import sha256 from "fast-sha256";
import util from "tweetnacl-util";
import axios, { AxiosRequestConfig } from "axios";
import { client } from "services/keycloak/client";
import { v4 } from "uuid";
import { IntlShape, useIntl } from "react-intl";
import { env } from "config";

type ConnectAccountsProps = {
  connections: LinkedAccount[]
}

export function ConnectAccounts(props: ConnectAccountsProps) {
  const keycloak = useKeycloak();
  const intl = useIntl();

  return (
    <>
      <div className="account-settings__title">
        {intl.formatMessage({ id: "jmix-account.connect-accounts.title" })}
      </div>
      <div>
        <List
          bordered
          dataSource={props.connections}
          renderItem={(item) => (
            <List.Item>
              <List.Item.Meta
                title={
                  <Space>
                    {getProviderIcon(item.providerName)}
                    {item.displayName}
                  </Space>
                }
              />
              <div>
                {
                  item.connected
                    ? intl.formatMessage({ id: "jmix-account.connect-accounts.connected" })
                    : <Button
                      icon={<LinkOutlined />}
                      type="link"
                      onClick={() => window.open(linkAccount(intl, item, keycloak))}
                    >
                      {intl.formatMessage({ id: "jmix-account.connect-accounts.connect-link" })}
                    </Button>
                }
              </div>
            </List.Item>
          )}
        />
      </div>
    </>
  );
}

function linkAccount(intl: IntlShape, linkedAccount: LinkedAccount, keycloak: KeycloakInstance): string {
  const keycloakHost = env.REACT_APP_KEYCLOAK_URL;
  const redirectUri = window.location.origin;
  const realm = keycloak.realm;
  const provider = linkedAccount.providerName;
  const nonce = v4();

  const sessionState = keycloak.idTokenParsed?.session_state;
  const clientId = keycloak.clientId;

  if (keycloak.token == null) {
    notification.error({
      message: intl.formatMessage({ id: "jmix-account.connect-account.error" }, { connectionName: linkedAccount.displayName }),
    });
    new Error("Connection error!");
  }

  const enc = new TextEncoder();
  const hashCode = sha256(enc.encode(`${nonce}${sessionState}${clientId}${provider}`));
  const hash = util.encodeBase64(hashCode);

  return `${keycloakHost}/realms/${realm}/broker/${provider}/link?client_id=${clientId}&redirect_uri=${redirectUri}&nonce=${nonce}&hash=${hash}`;
}

async function unlinkAccount(linkedAccount: LinkedAccount, keycloak: KeycloakInstance) {
  const keycloakHost = env.REACT_APP_KEYCLOAK_URL;
  const realm = keycloak.realm;
  const providerName = linkedAccount.providerName;

  const config: AxiosRequestConfig = {
    method: "delete",
    url: `${keycloakHost}/realms/${realm}/account/linked-accounts/${providerName}`,
    headers: {
      "Authorization": `Bearer ${client.token}`,
      "Content-Type": "application/json",
    },
  };

  await axios.request(config);
}


function getProviderIcon(provider: string): React.ReactNode {
  switch (provider) {
    case "google":
      return <GoogleOutlined />;
    case "github":
      return <GithubOutlined />;
    case "facebook":
      return <FacebookOutlined />;
    default :
      return <ShareAltOutlined />;
  }
}
